const decodeUnsafeCharacters = (str) => {
  return String(str).replace(/%(3A|3B)/g, (match, p1) => {
    return String.fromCharCode(parseInt(p1, 16));
  });
};

export default decodeUnsafeCharacters;
